import axios from 'axios'

const fetchPosts = (categoryId, page) => {
    let minDelay = new Promise((resolve, reject) => { setTimeout(resolve, 500) })
    let fetch = axios.get('/wp-json/rewild/v1/wellness', {
        params: {
            category: categoryId,
            page: page
        }
    })
    return Promise.all([minDelay, fetch]).then(([delay, res]) => { return res.data })
}

export default () => ({
    currentCategory: false,
    currentPage: 1,
    description: false,
    previewDescription: false,
    totalPosts: 0,
    fetching: false,
    loadingMore: false,
    posts: [],
    init() {
        this.selectCategory(0)
        this.description = this.$refs.all.dataset.description
    },
    async selectCategory(id) {
        if (this.currentCategory !== id) {
            this.currentCategory = id
            this.currentPage = 1
            this.fetching = true
            this.description = this.$el.dataset.description
            let data = await fetchPosts(id)
            this.totalPosts = data.count
            this.posts = data.posts
            this.fetching = false
        }
    },
    async loadMore() {
        this.currentPage += 1
        this.loadingMore = true
        let data = await fetchPosts(this.currentCategory, this.currentPage)
        this.totalPosts = data.count
        this.posts = this.posts.concat(data.posts)
        this.loadingMore = false
    },
    showPreviewDescription() {
        this.previewDescription = this.$el.dataset.description || false
    },
    hidePreviewDescription() {
        this.previewDescription = false
    },
})
